document.addEventListener('DOMContentLoaded', () => {
	const cursorIcon = document.querySelector('#custom-cursor')
	const cursorDefault = document.querySelector('#custom-cursor #default')
	const cursorHover = document.querySelector('#custom-cursor #hover')
	let hoverable = document.querySelectorAll(
		'input, button, a, label, .cursor-pointer'
	)

	hoverable.forEach(item => {
		item.addEventListener('mouseenter', e => {
			cursorDefault.style.opacity = 0
			cursorHover.style.opacity = 0.7
			if (item.classList.contains('dark-cursor')) {
				cursorHover.style.fill = '#00a4ff'
			} else {
				cursorHover.style.fill = '#ffffff'
			}
		})
		item.addEventListener('mouseleave', e => {
			cursorDefault.style.opacity = 1
			cursorHover.style.opacity = 0
		})
	})

	/////////////////////////
	//// Airplane Cursor ////
	/////////////////////////

	const $ = window.jQuery

	const cursorWidth = cursorIcon.getBoundingClientRect().width
	const cursorHeight = cursorIcon.getBoundingClientRect().height
	const cToWing = 13.16685 // This is predetermined based on the SVG itself. If the SVG changes, change this
	const wingAngleOffset = 0.3648863942100639 // This is also predetermined based on the SVG itself. If the SVG changes, change this

	let lastCursorPosition = {
		x: null,
		y: null,
		rads: null,
	}
	let lastScrollY = 0

	function updateCursor(posX, posY) {
		let changeX, changeY, rads, changeRads

		if (
			lastCursorPosition.x &&
			lastCursorPosition.y &&
			lastCursorPosition.rads != null
		) {
			changeX = posX - lastCursorPosition.x
			changeY = -posY + lastCursorPosition.y
			rads = Math.atan2(changeY, changeX) - Math.PI / 2
		} else {
			lastCursorPosition.x = posX
			lastCursorPosition.y = posY
			lastCursorPosition.rads = 0
		}

		// Only update the cursor if position change is significant enough
		if (Math.abs(changeX) > 2 || Math.abs(changeY) > 2) {
			cursorIcon.style.top = `${posY - cursorHeight / 2}px`
			cursorIcon.style.left = `${posX - cursorWidth / 2}px`
			cursorIcon.style.rotate = `${-rads}rad`

			lastCursorPosition.x = posX
			lastCursorPosition.y = posY
			lastCursorPosition.rads = rads
		}
	}

	/////////////////////////
	/////// Contrails ///////
	/////////////////////////

	const LINE_DURATION = 1
	const LINE_WIDTH_START = 2

	$(document).ready(function () {
		enableDrawingCanvas()
		resizeCanvas(window.innerWidth, window.innerHeight)
	})

	var active = true

	var canvas
	var context

	var newWidth = 0
	var newHeight = 0

	var lineColor = 'rgba(0, 164, 255, 0.60)'
	var lineDuration = LINE_DURATION
	var lineWidthStart = LINE_WIDTH_START

	var lPoints = new Array()
	var rPoints = new Array()

	///////////////////////
	// Program functions //
	///////////////////////

	// Find canvas reference & enable listeners
	function enableDrawingCanvas() {
		if (canvas === undefined) {
			canvas = document.getElementById('cursorCanvas')
			context = canvas.getContext('2d')
			enableListeners()
			init()
		}
	}

	// Initialize animation start
	function init() {
		draw()
	}

	// Draw current state
	function draw() {
		if (active) {
			animatePoints()
			window.requestAnimFrame(draw)
		}
	}

	// Update mouse positions
	function animatePoints() {
		context.clearRect(0, 0, context.canvas.width, context.canvas.height)

		var duration = (lineDuration * 1000) / 60

		drawPoints(lPoints, duration)
		drawPoints(rPoints, duration)
	}

	function drawPoints(points, duration) {
		var point, nextPoint, xc, yc

		context.lineJoin = 'round'
		context.strokeStyle = lineColor

		for (var i = 0; i < points.length - 2; i++) {
			context.beginPath()
			context.moveTo(xc, yc)

			point = points[i]
			nextPoint = points[i + 1]

			point.lifetime += 1

			if (point.lifetime > duration) {
				points.splice(i, 1)
				continue
			}

			// Begin drawing stuff!
			var inc = point.lifetime / duration // 0 to 1 over lineDuration

			var spreadRate
			spreadRate = lineWidthStart * (1 - inc)

			context.lineWidth = spreadRate

			xc = (point.x + nextPoint.x) / 2
			yc = (point.y + nextPoint.y) / 2

			context.quadraticCurveTo(point.x, point.y, xc, yc)

			context.stroke()
		}
	}

	function addPoint(x, y) {
		let rWingAngle = lastCursorPosition.rads - wingAngleOffset
		let rxOffset = cToWing * Math.cos(rWingAngle)
		let ryOffset = cToWing * Math.sin(rWingAngle)

		var rPoint = new Point(x + rxOffset, y - ryOffset, 0)
		rPoints.push(rPoint)

		let lWingAngle = lastCursorPosition.rads + wingAngleOffset + Math.PI
		let lxOffset = cToWing * Math.cos(lWingAngle)
		let lyOffset = cToWing * Math.sin(lWingAngle)

		var lPoint = new Point(x + lxOffset, y - lyOffset, 0)
		lPoints.push(lPoint)
	}

	//////////////////////////////
	// Less Important functions //
	//////////////////////////////

	// RequestAnimFrame definition
	window.requestAnimFrame = (function (callback) {
		return (
			window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function (callback) {
				window.setTimeout(callback, 1000 / 60)
			}
		)
	})()

	// Update canvas dimensions based on input
	function resizeCanvas(w, h) {
		if (context !== undefined) {
			context.canvas.width = w
			context.canvas.height = h

			newWidth = w
			newHeight = h
		}
	}

	function enableListeners() {
		// Listeners for mouse events
		window.addEventListener('mousemove', e => {
			updateCursor(e.pageX, e.pageY)
			addPoint(e.clientX, e.clientY)
		})
		window.addEventListener('scroll', e => {
			updateCursor(
				lastCursorPosition.x,
				lastCursorPosition.y + window.scrollY - lastScrollY
			)
			addPoint(e.clientX, e.clientY)
			lastScrollY = window.scrollY
		})

		// Listener to resize canvas on window resize
		window.addEventListener('resize', e => {
			resizeCanvas(window.innerWidth, window.innerHeight)
		})
	}

	// POINT CLASS
	// Cartesian location of where mouse location was previously at.
	var Point = class Point {
		constructor(x, y, lifetime) {
			this.x = x
			this.y = y
			this.lifetime = lifetime
		}
	}
})
